import React, { Suspense, lazy } from 'react';
import aws_exports from './aws-exports';
import { Amplify } from 'aws-amplify';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { Spin } from 'antd';
import './App.css';

const Home = lazy(() => import('./components/Home'));
const Tutorial = lazy(() => import('./components/Tutorial'));
const Submission = lazy(() => import('./components/Submission'));
const Result = lazy(() => import('./components/Result'));
const Viz = lazy(() => import('./components/Viz'));
const SingleViz = lazy(() => import('./components/VizSingle'));
const Detail = lazy(() => import('./components/Detail'));
const Select = lazy(() => import('./components/Select'));

Amplify.configure(aws_exports);

function PageLoading() {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '60vh',
    }}>
      <Spin size="large" />
    </div>
  );
}

export default function App() {

  return (
    <Router>
      <Suspense fallback={<PageLoading />}>
        <Switch>
          <Route path="/submission/:id">
            <Submission />
          </Route>

          <Route path="/submission">
            <Redirect to="/" />
          </Route>

          <Route path="/results">
            <Result />
          </Route>

          <Route path="/detail/:id">
            <Detail />
          </Route>

          <Route path="/viz/:data">
            <Viz />
          </Route>

          <Route path="/single_viz/:data">
            <SingleViz />
          </Route>

          <Route path="/tutorial">
            <Tutorial />
          </Route>

          <Route path="/">
            <Select />
          </Route>

        </Switch>
      </Suspense>
    </Router>
  )
};
